import * as types from "../actionTypes";

export function signalREventReceived(event) {
  return { type: types.SIGNAL_R_EVENT_RECEIVED, event };
}

export function serverEventReceived(event) {
  return { type: event.eventType, event };
}
